module.exports = __webpack_public_path__ + "static/media/bpm-logo.3f02d81e.jpg";